import { render, staticRenderFns } from "./artist.vue?vue&type=template&id=551a9365&scoped=true&"
import script from "./artist.vue?vue&type=script&lang=js&"
export * from "./artist.vue?vue&type=script&lang=js&"
import style0 from "./artist.vue?vue&type=style&index=0&id=551a9365&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551a9365",
  null
  
)

export default component.exports